import {StringIDFolder} from 'constants/FolderConstants';
import {RegistrySummary} from 'constants/RegistryConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import {SearchParams} from 'search/SearchConstants';

import {getDefaultProjectItemsSearchParams} from './ProjectsSearchParams';
import {getDefaultRegistrySearchParams} from './RegistrySearchParams';

export function getDefaultFolderSearchParams(folder: StringIDFolder): SearchParams {
  if (RegistryUtil.isRegistry(folder.source)) {
    return getDefaultRegistrySearchParams({...(folder.source as RegistrySummary), rootFolder: folder});
  } else {
    return getDefaultProjectItemsSearchParams(folder);
  }
}
